/**
 * Transaction status enum based on Kotlin TransactionStatus
 */
export enum TransactionStatus {
  OPENED = "OPENED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
}

/**
 * Transaction action enum based on Kotlin TransactionAction
 */
export enum TransactionAction {
  ADD = "ADD",
  SUBTRACT = "SUBTRACT",
  SETTLEMENT_INITIATED = "SETTLEMENT_INITIATED",
  MANUAL_WITHDRAWAL_INITIATED = "MANUAL_WITHDRAWAL_INITIATED",
}

/**
 * Transaction type enum based on Kotlin TransactionType
 */
export enum TransactionType {
  CUSTOMER_PAY = "CUSTOMER_PAY",
  REFUND_CUSTOMER = "REFUND_CUSTOMER",
  RELEASE_TO_PROVIDER = "RELEASE_TO_PROVIDER",
  CLOSE_RELEASE_TO_PROVIDER = "CLOSE_RELEASE_TO_PROVIDER",
  SETTLEMENT = "SETTLEMENT",
  MANUAL_WITHDRAWAL = "MANUAL_WITHDRAWAL",
}

/**
 * User role enum based on Kotlin ActorRole
 */
export enum UserRole {
  CUSTOMER = "CUSTOMER",
  PROVIDER = "PROVIDER",
}

/**
 * Display transaction type for wallet items
 */
export type DisplayTransactionType =
  | "Total Transferred" // Completed transactions that have been fully transferred
  | "Pending Transfer" // Transactions currently being processed
  | "Open Balance"; // Available balance ready for use

/**
 * Interface for transaction history item from API
 */
export interface TransactionHistory {
  domainId: string;
  amount: number;
  action: TransactionAction;
  type: TransactionType;
  actorRole: string | null;
  userId: string;
  userRole: UserRole | null;
  toAccount: string | null;
  date: string;
  cashedOut: boolean;
}

/**
 * Interface for wallet transaction data from API
 */
export interface WalletTransaction extends Transaction {
  domainId: string;
  title: string | null;
  status: TransactionStatus;
  walletHistories: TransactionHistory[];
  cashedOut: boolean;
  totalAmount: number;
  milestoneMetadata: {
    order: number | null;
  };
  partyCashOut?: {
    amountDue: number;
    cashOutAmount: number;
    fee: number;
    feePercentage: number;
    id: number;
  };
}

// Define the types
export type WalletHistoryRaw = {
  action: TransactionAction;
  amount: number;
  ref: string;
};

type WalletHistorySummarized = {
  action: TransactionAction;
  amount: number;
};

type Transaction = {
  id: number;
  rawWalletHistories: WalletHistoryRaw[];
  summarizedByAction: Record<TransactionAction, WalletHistoryRaw[]>;
  walletHistories: WalletHistorySummarized[];
};
